var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgSandTiles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 720,
    viewBox: "0 0 1280 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1280,
    y2: 720,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F3E8"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 720,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 84,
    width: 310,
    height: 214,
    rx: 28,
    fill: "#F0E6D6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 428,
    y: 84,
    width: 310,
    height: 214,
    rx: 28,
    fill: "#FFFFFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 768,
    y: 84,
    width: 424,
    height: 214,
    rx: 28,
    fill: "#E9DCC6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 326,
    width: 424,
    height: 310,
    rx: 28,
    fill: "#FFFFFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 542,
    y: 326,
    width: 286,
    height: 310,
    rx: 28,
    fill: "#F2EBDE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 858,
    y: 326,
    width: 334,
    height: 310,
    rx: 28,
    fill: "#F8F2E7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1128,
    cy: 150,
    r: 54,
    fill: "#E8CFA2",
    fillOpacity: 0.44
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 516,
    r: 70,
    fill: "#EADFCB",
    fillOpacity: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSandTiles);
export default __webpack_public_path__ + "static/media/bg-sand-tiles.6ecaaac429a07e298d0dc54bd4615a5f.svg";
export { ForwardRef as ReactComponent };